import React, {Component} from "react";

import { MEMBER_TOKEN }   from "actions/const";

import MassUpload         from "./MassUpload";
import Create         from "./Create";

export default class FormContainer extends Component {
  render () {
    let {
      MemberToken
    } = this.props;

    let {
      formType,
      selectedData
    } = MemberToken;

    switch (formType.toUpperCase()) {
      case "CREATE":
      case "UPDATE":
        return (<Create {...this.props}/>);
        break;
      case "MASS_UPLOAD":
        return (<MassUpload {...this.props}/>);
        break;
      default:
        return "";
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      MEMBER_TOKEN,
      {
        selectedData: null,
        formType: "",
        formId: "",
        formTitle: "",

        csvFile: null,
        form_memberId: '',
        form_cardType: '',
  
        memberId_isChecking: false,
        memberId_isExisting: false
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/Home/FormContainer/index.js